import { Button, FeaturedIcon } from "@light-technology/components";
import { SlashCircle01 } from "@untitledui/icons";

export const ForbiddenPage = () => {
  return (
    <div className="flex size-full flex-col items-center justify-center">
      <FeaturedIcon
        color="error"
        size="xl"
        theme="light"
        icon={SlashCircle01}
      />
      <div className="my-3xl text-center">
        <div className="text-display-xs">You don't have permission</div>
        <div className="text-tertiary">
          This page requires additional permissions.
        </div>
      </div>
      <Button color="secondary" size="lg" href="/">
        Return to Home
      </Button>
    </div>
  );
};
